import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateConfigPipe } from '../pipes/translate-config.pipe';

@Component({
    selector: 'platform-chip',
    standalone: true,
    imports: [TooltipModule, CommonModule, TranslateConfigPipe],
    template: `
        <span
            class="max-w-13rem align-items-center border-1 flex height-24 padding-px-10 padding-py-10 radius-3xl  gap-2"
            [pTooltip]="tooltipContent"
            tooltipPosition="bottom"
            [id]="removable ? 'removable-chip' : 'non-removable-chip'"
            [ngClass]="{
                'surface-border': disabled,
                'border-primary-900': !disabled,
            }"
            (click)="onClickChip()"
        >
            <span
                class="overflow-hidden text-overflow-ellipsis text-sm  font-medium white-space-nowrap"
                [ngClass]="{
                    'text-gray-300': !disabled,
                    'text-primary-900': disabled,
                }"
            >
                {{ value | translateConfig }}
            </span>
            @if (removable) {
                <span
                    class="flex align-items-center border-1 bg-primary-400 border-primary-400 w-1rem h-1rem border-circle"
                    [ngClass]="{
                        'cursor-pointer': removable,
                    }"
                    (click)="onRemoveChip()"
                >
                    <i
                        class="align-content-center flex justify-content-center pi pi-times text-xsmall w-full"
                        [ngClass]="{
                            'text-primary-900': disabled,
                        }"
                    ></i>
                </span>
            }
        </span>
        <ng-template #tooltipContent>
            <div class="flex">
                {{ value | translateConfig }}
            </div>
        </ng-template>
    `,
    styles: [
        `
            :host {
                display: inline-block;
            }
        `,
    ],
})
export class PlatformChipComponent implements OnInit {
    @Input() value!: string;
    @Input() removable: boolean = true;
    @Input() disabled: boolean = false;
    @Output() onRemove = new EventEmitter<string>();
    @Output() onClick = new EventEmitter<string>();

    ngOnInit(): void {}

    onRemoveChip() {
        if (!this.removable || this.disabled) {
            return;
        }
        this.onRemove.emit(this.value);
    }

    onClickChip() {
        if (!this.disabled) {
            this.onClick.emit(this.value);
        }
    }
}
